export default __webpack_public_path__ + "static/media/gifts-border.69d3ac86.svg";